import React, { Component } from "react";
import { Link } from 'react-router-dom'
import dotenv from 'dotenv';
import Helper from '../DevServices/Helper'
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import { compose } from "redux";
import { 
    //thunkTest,
    t_api_req_device_list_by_user_role,
    t_get_all_collections_info,
} from "../../reducers/dev";
//import Xd from "./Xd"




dotenv.config();

class PagexSensCollection extends Component {
/*   constructor(props) {
    super(props);
    this.handlelocationId = this.handlelocationId.bind(this);
    this.onChangelocationId= this.onChangelocationId.bind(this);

    this.state = {
      //locationId: 0,
      isValidate: false,
      loading: false,
    };
  } */

  componentWillUnmount(){
    //console.log('Good Bye!')
/*     this.props.reset_LocIdInfo() */
  }

  componentDidMount(){
    //if (this.props.user) this.props.thunkTest(this.props.user.accessToken)
    if (this.props.user) this.props.t_api_req_device_list_by_user_role()

    this.props.t_get_all_collections_info()
    //console.log(rx_collection_id)  

  }



  render() {
        // Check if the user is authenticated or exists
        if (!this.props.user) {
          // Redirect to an external URL
          //window.location.href = "https://google.com";
          window.location.href = process.env.REACT_APP_HOST+"/login";
          return null; // Return null to avoid rendering anything else
        }
    //if (this.props.user) return <Redirect to="/login" />;
    //const o = this.props.dev.sensors_collection_id.data_10_days_back.collection_info_by_id
    if (!this.props.dev.sensors_all_collections.length) return null;

    return (
      <>
    <div className="container mt-5">
    <h3 className="text-info">Device Collections</h3>
      <div className="container">

        <div className="row">
          {
            this.props.dev.sensors_all_collections.map((v,i)=>(
              <CardItem key={i}
                id={v.id}
                description={v.description}
                dev_qty={v.dev_qty}
              />
            ))
          }

        </div>

      </div>

    <hr />

      <Helper props={this.props.dev.sensors_all_collections} />
      <Helper props={this.props.dev.sensors_collection_id} />

      
    </div>



</>

    );
  }
}

function mapStateToProps(state) {
  //console.log(state)
  const { user, test } = state.auth;

  return {
    user,
    test,
    dev: state.dev,
/*    location: state.location */
  };
}

  const mapDispatchToProps = { 
    //thunkTest,
    t_api_req_device_list_by_user_role,
    t_get_all_collections_info,
  }



export default compose(
  connect(mapStateToProps, mapDispatchToProps)
  //withAuthRedirect
)(PagexSensCollection);
/* 
                id={v.id}
                description={v.description}
                dev_qty={v.dev_qty}
*/

const CardItem = (props) => {
  const {id, description, dev_qty} = props
  //The same Height
  return (
    <div className="col-md-4 d-flex">
      <div className="card mb-4 box-shadow flex-fill">
        <div className="card-header">Collection #{id}</div>
        <div className="card-body d-flex flex-column">
          <p className="card-text">{description}</p>
          <div className="d-flex justify-content-between align-items-center mt-auto">
            <div className="btn-group">
              <Link to={`/sensors_collection/${id}`}>
                <button type="button" className="btn btn-sm btn-outline-secondary">Details</button>
              </Link>
            </div>
            <small className="text-muted">{dev_qty} devs qty</small>
          </div>
        </div>
      </div>
    </div>
  )
}